import Group from "./Group";
import Radio from "./Radio";

Radio.Group = Group;

export default Radio;
